import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Datepicker} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Datepicker, {
            'type': 'year',
            'ev-$model:value': function($v) {
                $this.set('year', $v);
            },
            'value': $this.get('year')
        }),
        _$cc(Datepicker, {
            'type': 'month',
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('month', $v);
            },
            'value': $this.get('month')
        })
    ], 4 /* HasNonKeyedChildren */);
};